import {Link} from '@shopify/hydrogen';
import {HTMLAttributes} from 'react';
import {useNavigationStore} from '../../../hooks/useNavigationStore';
import {SanityMenuLink} from '../../../types';
import clsx from 'clsx';

type Props = {
  link: SanityMenuLink;
  className?: string;
} & HTMLAttributes<HTMLElement>;

export default function NavigationLink({link, className}: Props) {
  const {handleClose} = useNavigationStore();

  switch (link._type) {
    case 'linkCollection':
      return (
        <Link
          className={clsx(
            className,
            'transition-opacity duration-500 ease-out hover:opacity-40',
          )}
          to={`${link.collection.slug}`}
          onClick={handleClose}
        >
          {link.title}
        </Link>
      );
    case 'linkInternal':
      return (
        <Link
          className={clsx(
            className,
            'transition-opacity duration-500 ease-out hover:opacity-40',
          )}
          to={`${link.slug}`}
          onClick={handleClose}
        >
          {link.title}
        </Link>
      );
    case 'linkExternal':
      return (
        <div className="flex" key={link._key}>
          <a
            className={clsx(
              className,
              'transition-opacity duration-500 ease-out hover:opacity-40',
            )}
            href={link.url}
            rel="noreferrer"
            target="_blank"
            onClick={handleClose}
          >
            {link.title}
          </a>
        </div>
      );
    default:
      return null;
  }
}
